import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "connected-react-router";
import { Pagination } from "@zendesk/self-service-components";
import { Spinner } from "@zendeskgarden/react-loaders";
import { getCurrentBrandId } from "@zendesk/knowledge-context";
import * as staffActions from "../../../../actions/staffUserSegments";
import * as signedInActions from "../../../../actions/signedInUserSegments";
import UserSegment from "../UserSegment";

import styles from "./index.css";

export class List extends Component {
  constructor(props) {
    super(props);

    this.onPageSelected = this.onPageSelected.bind(this);
  }
  componentWillMount() {
    const { fetchUserSegments, page } = this.props;
    fetchUserSegments(page);
  }

  onPageSelected(page) {
    const { fetchUserSegments, type, pushPage } = this.props;

    const compatiblePageNumber = page + 1;
    fetchUserSegments(compatiblePageNumber);
    pushPage({
      pathname: `/knowledge/user_segments/${type}/${compatiblePageNumber}`,
      search: `?brand_id=${getCurrentBrandId()}`,
    });
  }

  render() {
    const { isFetching, userSegments, pageCount, page } = this.props;

    const pagination = pageCount > 1 && (
      <Pagination
        total={pageCount}
        currentPage={page - 1}
        onPageSelected={this.onPageSelected}
      />
    );

    if (isFetching) {
      return (
        <div>
          <div className={styles.loader}>
            <Spinner />
          </div>

          {pagination}
        </div>
      );
    }

    return (
      <div>
        <div>
          {userSegments.map(us => <UserSegment key={us.id} userSegment={us} />)}
        </div>
        {pagination}
      </div>
    );
  }
}

List.propTypes = {
  userSegments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      built_in: PropTypes.bool.isRequired,
    })
  ),
  type: PropTypes.oneOf(["staff", "signedIn"]).isRequired,
  isFetching: PropTypes.bool,
  pageCount: PropTypes.number,
  page: PropTypes.number,
  fetchUserSegments: PropTypes.func,
  pushPage: PropTypes.func,
};

List.defaultProps = {
  userSegments: [],
  isFetching: false,
  pageCount: 1,
  page: 1,
};

const mapStateToProps = (state, { type, page }) => {
  const typeState =
    type === "staff" ? state.staffUserSegments : state.signedInUserSegments;

  return {
    type: type,
    userSegments: typeState.list,
    isFetching: typeState.isFetching,
    pageCount: typeState.pageCount,
    page,
  };
};

const mapDispatchToProps = (dispatch, { type }) => {
  const actions = type === "staff" ? staffActions : signedInActions;
  return bindActionCreators({ ...actions, pushPage: push }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(List);



// WEBPACK FOOTER //
// ./src/components/UserSegments/components/List/index.js